/**
 * The IANA zones a host can pick for a trip.
 *
 * `Intl.supportedValuesOf('timeZone')` is the source, so the list is exactly the
 * zones this browser can format in — a zone offered here can always be used by
 * `resolveTripTimeZone` and the rest of lib/tripTime.ts. Older engines lack the
 * API (and some omit "UTC"), so a short fallback keeps the picker usable.
 */
const FALLBACK_ZONES = [
  'UTC',
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Sao_Paulo', 'Europe/London', 'Europe/Lisbon', 'Europe/Madrid', 'Europe/Paris',
  'Europe/Rome', 'Africa/Johannesburg', 'Asia/Dubai', 'Asia/Kolkata', 'Asia/Bangkok',
  'Asia/Tokyo', 'Australia/Sydney', 'Pacific/Auckland',
];

export function listTimeZones(current?: string | null): string[] {
  let zones: string[] = [];
  try {
    const supported = (Intl as unknown as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
    if (typeof supported === 'function') zones = supported('timeZone');
  } catch {
    zones = [];
  }
  const set = new Set(zones.length ? zones : FALLBACK_ZONES);
  set.add('UTC');
  // A saved zone this browser does not list must still be selectable, or the
  // picker would show an empty box for a group that has one.
  const saved = (current || '').trim();
  if (saved) set.add(saved);
  return [...set].sort((a, b) => a.localeCompare(b));
}
